<div class="lock-container">
  <div class="lock-content">
    <div class="logo-section">
      <img class="logo" src="assets/images/logo.svg" alt="Rubii">
    </div>
    
    <div class="lock-message">
      <h1 class="title">Your account has been temporarily locked</h1>
      <p class="description">We've detected multiple failed verification attempts. For your security, your account has been temporarily disabled. </p>
      <p class="description">If you believe this is a mistake or need assistance regaining access, please contact Rubii Support at <a href="mailto:support@rubii.io">support@rubii.io</a></p>
    </div>
    
    <div class="back-to-login">
      <button mat-raised-button class="rubii-btn" color="primary" >Back to Login</button>
    </div>
  </div>
</div>